import * as actionTypes from "../actionTypes";

const initialState = {
    subCategoryData: [],
    subCatgeoryDataByCategoryId: []
};

const subCategoryReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        case actionTypes.SET_SUB_CATEGORY: {
            return {
                ...state,
                subCategoryData: payload,
            };
        }
        case actionTypes.SET_SUB_CATEGORY_BY_CATEGORY_ID: {
            return {
                ...state,
                subCatgeoryDataByCategoryId: payload,
            };
        }
        default: {
            return state;
        }
    }
};

export default subCategoryReducer;